<div class="col-2 custom-button">
  @if (column.includes('CorridorEnabled')) {
    <div class="signifyBookmd ml-15">Enable feature<input type="checkbox"
      [checked]="corridorEnabledval" [(ngModel)]="ngModelval['CorridorEnabled']" name="RCorridorset"
      class="primary-checkbox" id="RCorridorset" (change)="rSetChanged($event.target.checked)" />
      <label class="enable-feature" for="RCorridorset"><span id="Corridor-enable-feature-checkbox" class="extra-border-enablefeat"></span></label>
    </div>
  }
</div>
@if (!quickConfigvalue) {
  <div class="row" [ngClass]="{'disbaleStyle': corridordisbaled}">
    <app-corridor-graph class="col-10"></app-corridor-graph>
  </div>
}
@if (column.includes('NormalLevel') ) {
  <div id="corridor_normalLevel_container" class="row slider-container"
    [ngClass]="{'dtldisbaled': corridordisbaled}">
    <div class="col-1 label signifyBookmd text-mindim dim-margin">Normal level</div>
    <!-- Added id here-->
    @if (!quickConfigvalue) {
      <span id="corridor_normalLevel_minvalue"class="signifyBookmd text-mindim  sliderMinValue col-1"
      >{{corridorNormalMin}}</span>
    }
    @if (quickConfigvalue) {
      <div class="col-2">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-2 minValMargin">
            <span class=" signifyBookmd minValue"> min {{ corridorNormalMin }}</span>
          </div>
          <div class="col-3">
            <span class="signifyBookmd maxValue"> max {{ corridorNormalMax }}</span>
          </div>
        </div>
      </div>
    }
    @if (!quickConfigvalue) {
      <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
        <ngx-slider type="normalType" [options]=corridorNormalOption [(value)]=NormalLevelValue
          (userChangeEnd)="corridorNormalValueChange($event.value)" ngDefaultControl>
        </ngx-slider>
      </div>
    }
    <!-- Added id here-->
    @if (!quickConfigvalue) {
      <span id="corridor_normalLevel_maxvalue"  class="signifyBookmd text-mindim  col-1 maxValueCss">{{corridorNormalMax}}</span>
    }
    <div class="row form-group col-3">
      <div class="d-flex align-items-center">
        <input type="number" [(value)]="ngModelval['NormalLevelValue']"
          (input)="textValChanged($event.target.value, 'NormalLevel')" id="CorridorMode_NormalLevel_txtbox"
          (keypress)="numberOnly($event)"
          [ngClass]="{'showingError': inputError['NormalLevel']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
          class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
          [disabled]="corridordisbaled" />
          <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">
          (&#8776;{{calculatedPercentageVal}} %)</p>
        </div>
      </div>
    </div>
  }
  @if (column.includes('BackgroundLevel') ) {
    <div id="corridor_BackgroundLevel_container" class="row slider-container"
      [ngClass]="{'dtldisbaled': corridordisbaled}">
      <div class="col-1 label signifyBookmd text-mindim dim-margin">Background level</div>
      <!-- Added id here-->
      @if (!quickConfigvalue) {
        <span id="corridor_backgroundLevel_minvalue" class="signifyBookmd text-mindim  sliderMinValue col-1"
        >{{corridorBackgroundLevelMin}}</span>
      }
      @if (quickConfigvalue) {
        <div class="col-2">
          <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
              <span class=" signifyBookmd minValue"> min {{ corridorBackgroundLevelMin }}</span>
            </div>
            <div class="col-3">
              <span class="signifyBookmd maxValue"> max {{ corridorBackgroundLevelMax }}</span>
            </div>
          </div>
        </div>
      }
      @if (!quickConfigvalue) {
        <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
          <ngx-slider [options]=corridorBackgroundLevelOption [(value)]=BackgroundLevelValue
            (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="corridorBackgroundLevelChange($event.value)"
            ngDefaultControl>
          </ngx-slider>
        </div>
      }
      <!-- Added id here-->
      @if (!quickConfigvalue) {
        <span id="corridor_backgroundLevel_maxvalue"class="signifyBookmd text-mindim  col-1 maxValueCss"
        >{{corridorBackgroundLevelMax}}</span>
      }
      <div class="row form-group col-3">
        <div class="d-flex align-items-center">
          <input type="tel" [(value)]="ngModelval['BackgroundLevelValue']"
            (input)="textValChanged($event.target.value, 'BackgroundLevel')" id="CorridorMode_BackgroundLevel_txtbox"
            (keypress)="numberOnly($event)"
            [ngClass]="{'showingError': inputError['BackgroundLevel']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard ': quickConfigvalue===true}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="corridordisbaled" />
            <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">
            (&#8776;{{calculatedPercentageVal1}} %)</p>
          </div>
        </div>
      </div>
    }
    @if (column.includes('DelayTime') ) {
      <div id="corridor_DelayTime_container" class="row slider-container"
        [ngClass]="{'dtldisbaled': corridordisbaled}">
        <div class="col-1 label signifyBookmd text-mindim dim-margin">Delay time</div>
        <!-- Added id here-->
        @if (!quickConfigvalue) {
          <span id="corridor_delayTime_minvalue" class="signifyBookmd text-mindim  sliderMinValue col-1"
          >{{corridorDelayTimeMin}}</span>
        }
        @if (quickConfigvalue) {
          <div class="col-2">
            <div class="row">
              <div class="col-2"></div>
              <div class="col-2 minValMargin">
                <span class=" signifyBookmd minValue"> min {{ corridorDelayTimeMin }}</span>
              </div>
              <div class="col-3">
                <span class="signifyBookmd maxValue"> max {{ corridorDelayTimeMax }}</span>
              </div>
            </div>
          </div>
        }
        @if (!quickConfigvalue) {
          <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
            <ngx-slider [options]=corridorDelayTimeOption [(value)]=DelayTimeValue
              (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="corridorDelayTimeChange($event.value)"
              ngDefaultControl>
            </ngx-slider>
          </div>
        }
        <!-- Added id here-->
        @if (!quickConfigvalue) {
          <span id="corridor_delayTime_maxvalue" class="signifyBookmd text-mindim  col-1 maxValueCss"
          >{{corridorDelayTimeMax}}</span>
        }
        <div class="row form-group col-3">
          <div class="d-flex align-items-center">
            <input type="tel" [(value)]="ngModelval['DelayTimeValue']"
              (input)="textValChanged($event.target.value, 'DelayTime')" id="CorridorMode_DelayTime_txtbox"
              (keypress)="numberOnly($event)" (focusout)="changeMultiples($event.target.value, 'DelayTime')"
              [ngClass]="{'showingError': inputError['DelayTime']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
              class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
              [disabled]="corridordisbaled" />
              <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">s</p>
            </div>
          </div>
        </div>
      }
      @if (column.includes('FadeTimeIndex') ) {
        <div id="corridor_FadeTimeIndex_container" class="row slider-container"
          [ngClass]="{'dtldisbaled': corridordisbaled}">
          <div class="col-1 label signifyBookmd text-mindim dim-margin">Fade time</div>
          <!-- Added id here-->
          @if (!quickConfigvalue) {
            <span id="corridor_fadeTime_minvalue" class="signifyBookmd text-mindim  sliderMinValue col-1"
            >{{corridorFadeTimeIndexMin}}</span>
          }
          @if (quickConfigvalue) {
            <div class="col-2">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-2 minValMargin">
                  <span class=" signifyBookmd minValue"> min {{ corridorFadeTimeIndexMin }}</span>
                </div>
                <div class="col-3">
                  <span class="signifyBookmd maxValue"> max {{ corridorFadeTimeIndexMax }}</span>
                </div>
              </div>
            </div>
          }
          @if (!quickConfigvalue) {
            <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
              <ngx-slider [options]=corridorFadeTimeIndexOption [(value)]=FadeTimeIndexValue
                (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="corridorFadeTimeIndexChange($event.value)"
                ngDefaultControl>
              </ngx-slider>
            </div>
          }
          <!-- Added id here-->
          @if (!quickConfigvalue) {
            <span id="corridor_fadeTime_maxvalue" class="signifyBookmd text-mindim  col-1 maxValueCss"
            >{{corridorFadeTimeIndexMax}}</span>
          }
          <div class="row form-group col-3">
            <div class="d-flex align-items-center">
              <input type="tel" [(value)]="ngModelval['FadeTimeIndexValue']"
                (input)="textValChanged($event.target.value, 'FadeTimeIndex')" id="CorridorMode_FadeTime_txtbox"
                (keypress)="numberOnly($event)" (keyup)="textValChanged($event.target.value, 'FadeTimeIndex')"
                [ngClass]="{'showingError': inputError['FadeTimeIndex']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                [disabled]="corridordisbaled" />
                @if (fadeTimeDynamicVal==='Extended fade') {
                  <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">{{fadeTimeDynamicVal}}</p>
                } @else {
                  <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">&#40;{{fadeTimeDynamicVal}}
                  s&#41;</p>
                }
              </div>
            </div>
          </div>
        }
        @if (column.includes('ProlongTime') ) {
          <div id="corridor_ProlongTime_container" class="row slider-container"
            [ngClass]="{'prolongTimeDisbaled': InfiniteDisabledVal, 'dtldisbaled': corridordisbaled}">
            <div class="col-1 label signifyBookmd text-mindim dim-margin">Prolong time</div>
            <!-- Added id here-->
            @if (!quickConfigvalue) {
              <span id="corridor_prolongTime_minvalue" class="signifyBookmd text-mindim  sliderMinValue col-1"
              >{{corridorProlongTimeMin}}</span>
            }
            @if (quickConfigvalue) {
              <div class="col-2">
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-2 minValMargin">
                    <span class=" signifyBookmd minValue"> min {{ corridorProlongTimeMin }}</span>
                  </div>
                  <div class="col-3">
                    <span class="signifyBookmd maxValue"> max {{ corridorProlongTimeMax }}</span>
                  </div>
                </div>
              </div>
            }
            @if (!quickConfigvalue) {
              <div class="col-6 curvePadding sliderCss"
                [ngClass]="{'disbaleStyle': InfiniteDisabledVal, 'dtldisbaled': corridordisbaled}">
                <ngx-slider [options]=corridorProlongTimeOption [(value)]=ProlongTimeValue
                  (userChangeEnd)="corridorProlongTimeChange($event.value)" ngDefaultControl>
                </ngx-slider>
              </div>
            }
            <!-- Added id here-->
            @if (!quickConfigvalue) {
              <span id="corridor_prolongTime_maxvalue" class="signifyBookmd text-mindim  col-1 maxValueCss"
              >{{corridorProlongTimeMax}}</span>
            }
            <div class="row form-group col-3">
              <div class="d-flex align-items-center">
                <input type="tel" [(value)]="ngModelval['ProlongTimeValue']"
                  (input)="textValChanged($event.target.value, 'ProlongTime')" id="CorridorMode_ProlongTime_txtbox"
                  (keypress)="numberOnly($event)" (focusout)="changeMultiples($event.target.value, 'ProlongTime')"
                  [ngClass]="{'showingError': inputError['ProlongTime']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                  class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                  [disabled]="InfiniteDisabledVal || corridordisbaled" />
                  <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">s</p>
                </div>
              </div>
              @if (!quickConfigvalue) {
                <div class="col-1"></div>
              }
              <div class="col-3 signifyBookmd sliderMinValue">Infinite
                <input type="checkbox" [disabled]="corridordisbaled" [checked]="InfiniteDisabledVal"
                  [(ngModel)]="ngModelval['infiniteDisabled']" name="lampDisabled" class="primary-checkbox" id="lampDisabled"
                  (change)="infinteDisabled($event.target.checked)" />
                  <label [ngClass]="{'disablingInfinteCheck': corridordisbaled, 'infiniteCss': quickConfigvalue===true }"
                    class="enable-feature" for="lampDisabled" aria-label="Infinite"><span id="corridor_infinite_checkbox"class="extra-border-enablefeat"></span></label>
                  </div>
                </div>
              }
              @if (column.includes('ActivationTime') ) {
                <div id="corridor_ActivationTime_container" class="row slider-container"
                  [ngClass]="{'dtldisbaled': corridordisbaled}">
                  <div class="col-1 label signifyBookmd text-mindim dim-margin">Activation time</div>
                  <!-- Added id here-->
                  @if (!quickConfigvalue) {
                    <span id="corridor_activationTime_minvalue"class="signifyBookmd text-mindim  sliderMinValue col-1"
                    >{{corridorActivationTimeMin}}</span>
                  }
                  @if (quickConfigvalue) {
                    <div class="col-2">
                      <div class="row">
                        <div class="col-2"></div>
                        <div class="col-2 minValMargin">
                          <span class=" signifyBookmd minValue"> min {{ corridorActivationTimeMin }}</span>
                        </div>
                        <div class="col-3">
                          <span class="signifyBookmd maxValue"> max {{ corridorActivationTimeMax }}</span>
                        </div>
                      </div>
                    </div>
                  }
                  @if (!quickConfigvalue) {
                    <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': corridordisbaled}">
                      <ngx-slider [options]=corridorActivationTimeOption [(value)]=ActivationTimeValue
                        (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="corridorActivationTimeChange($event.value)"
                        ngDefaultControl>
                      </ngx-slider>
                    </div>
                  }
                  <!-- Added id here-->
                  @if (!quickConfigvalue) {
                    <span id="corridor_activationTime_maxvalue" class="signifyBookmd text-mindim  col-1 maxValueCss"
                    >{{corridorActivationTimeMax}}</span>
                  }
                  <div class="row form-group col-3">
                    <div class="d-flex align-items-center">
                      <input type="number" [(value)]="ngModelval['ActivationTimeValue']"
                        (input)="textValChanged($event.target.value, 'ActivationTime')" id="CorridorMode_ActivationTime_txtbox"
                        (keypress)="numberOnly($event)"
                        [ngClass]="{'showingError': inputError['ActivationTime']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                        class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                        [disabled]="corridordisbaled" />
                        <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">s</p>
                      </div>
                    </div>
                  </div>
                }
                <div class="row note-back">
                  <span class=" col-8 note-text signifyBookmd">Note: Corridor mode can only be enabled when Touch and Dim is
                  enabled</span>
                </div>
